import { render, staticRenderFns } from "./review-config.vue?vue&type=template&id=2290def8&scoped=true"
import script from "./review-config.vue?vue&type=script&lang=js"
export * from "./review-config.vue?vue&type=script&lang=js"
import style0 from "./review-config.vue?vue&type=style&index=0&id=2290def8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290def8",
  null
  
)

export default component.exports